import { memo } from 'react';
import { motion } from 'framer-motion';
import { Box, Button } from '@chakra-ui/react';

import { menuToggleVariants } from 'constants/header';
import { DEFAULT_TRANSITION, EMPTY_OBJECT, HEADER_BREAKPOINT } from 'constants/global';

const MenuToggle = ({ isOpen, ...props }) => (
  <Button
    id="header-menu-toggle-btn"
    boxSize="40px"
    bg="rgba(255, 250, 234, 0.3)"
    borderRadius="full"
    p="0 10px"
    pos="fixed"
    top={{ mobile: '10px', tablet: '18px' }}
    right={{ mobile: '16px', tablet: '20px' }}
    zIndex="sticky"
    filter={isOpen && 'brightness(0) invert(1)'}
    hideFrom={HEADER_BREAKPOINT}
    _hover={EMPTY_OBJECT}
    _active={EMPTY_OBJECT}
    {...props}
  >
    <Box
      as={motion.svg}
      animate={isOpen ? 'open' : 'closed'}
      initial={false}
      boxSize="full"
      viewBox="0 0 36 36"
      objectFit="cover"
      stroke="deepBlue"
      transition={DEFAULT_TRANSITION}
      cursor="pointer"
    >
      {menuToggleVariants?.map((val, i) => (
        <Path key={i} {...val} />
      ))}
    </Box>
  </Button>
);

const Path = props => (
  <Box as={motion.path} fill="transparent" strokeWidth="2" strokeLinecap="round" {...props} />
);

export default memo(MenuToggle);
